import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { Link } from 'react-router-dom'

import User from '../User'
import { HeaderBar, StyledHeader } from './styled'
import logo from '../../assets/img/logo.png'

const Header = props => {
  const { user, changeStore } = props
  return (
    <>
      <HeaderBar />
      <StyledHeader>
        <Link to={'/'}>
          <img src={logo} alt={'logo'} height={32} />
        </Link>
        {!isEmpty(user) ? (
          <User user={user} onClick={user.authorizations?.permissions?.isAdmin ? changeStore : null} />
        ) : null}
      </StyledHeader>
    </>
  )
}
Header.propTypes = {
  user: PropTypes.object
}
export default Header